import type { ComponentType } from 'react'

import { cn } from '@/lib/tailwind.utils'
import { Button } from '@/components/ui/button'

type RelatedUseCaseItemProps = {
  title: string
  Icon: ComponentType<{ size?: number }>
  accentBgClassName: string
  onView: () => void
}

const RelatedUseCaseItem = ({
  title,
  Icon,
  accentBgClassName,
  onView,
}: RelatedUseCaseItemProps) => {
  return (
    <div className="flex items-center gap-3 rounded-md px-2 py-2 hover:bg-muted/50">
      <div
        className={cn(
          'flex h-8 w-8 shrink-0 items-center justify-center rounded-full',
          accentBgClassName,
        )}
      >
        <Icon size={80} />
      </div>

      <span className="flex-1 text-sm text-foreground">{title}</span>

      <Button variant={'ghost'} onClick={onView}>
        View →
      </Button>
    </div>
  )
}

export default RelatedUseCaseItem
